import React, { useState, useEffect } from "react";
import {
  makeStyles,
  withStyles,
  useTheme,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { Divider, Hidden, Container } from "@material-ui/core";
import ScreenSize from "./ScreenSize";
import useWindowDimensions from "./services/useWindowDimensions";
import { GiArtilleryShell } from "react-icons/gi";
import { useDispatch, useSelector } from "react-redux";
import { deleteFreshchat, initFreshchatSession } from "./services/freshchat";
import { HiMenu } from "react-icons/hi";
import MobileNavbarDrawer from "./components/MobileNavbarDrawer";
import DesktopNavbar from "./components/Navbar";
import Navbar from "./components/Navbar";
import useScript from "./services/useScript";
import { SET_DARK_MODE } from "./redux/types";

export default function PreLayout(props) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  let history = useHistory();
  let location = useLocation();
  const loginId = useSelector((state) => state.trading.LOGIN_ID);
  const [swipeableOpen, setSwipeableOpen] = useState(false);
  const { height, width } = useWindowDimensions();
  useScript("https://app.getbeamer.com/js/beamer-embed.js");

  var modeL = JSON.parse(localStorage.getItem("mode"));

  const token = useSelector((state) => state.trading.TOKEN);
  const darkState = useSelector((state) => state.trading.DARK_MODE);

  const darkTheme = createMuiTheme({
    ...theme,
    palette: {
      type: darkState ? "dark" : "light",
      primary: {
        main: "#3AC4AB",
      },
      secondary: {
        main: "#ffffff",
      },
      background: {
        paper: darkState ? "#151828" : "white",
        default: darkState ? "#090D1C" : "#F7F7F7",
      },
    },
  });

  useEffect(() => {
    initFreshchatSession();
    // window.Beamer?.destroy();

    window.beamer_config = {
      product_id: "byrdvtHp31966", //DO NOT CHANGE: This is your product code on Beamer
      button: false,
    };
    window.Beamer?.init();
    // setTimeout(() => {
    //   window.Beamer?.init();
    // }, 1000);

    return () => {
      window.Beamer?.destroy(true);
    };
  }, []);

  useEffect(() => {
    try {
      if (swipeableOpen) {
        document.querySelector(
          "#fc_frame, #fc_frame.fc-widget-normal"
        ).style.display = "none";
      } else {
        document.querySelector(
          "#fc_frame, #fc_frame.fc-widget-normal"
        ).style.display = "block";
      }
    } catch (e) {}
  }, [swipeableOpen]);

  useEffect(() => {
    if (
      location.pathname === "/" ||
      location.pathname === "/login" ||
      location.pathname === "/createacc" ||
      location.pathname === "/careers" ||
      location.pathname === "/contactus" ||
      location.pathname === "/aboutus" ||
      location.pathname === "/bugbounty" ||
      location.pathname === "/feespage" ||
      location.pathname === "/tandc"
    ) {
      dispatch({ type: SET_DARK_MODE, payload: true });
    }
    // if (
    //   window.innerWidth <= 768 &&
    //   !["/login", "/createacc"].includes(location.pathname)
    // ) {
    //   let timer = 1;

    //   let interval = setInterval(() => {
    //     timer++;

    //     if (detectIfFreshchatHasLoaded()) {
    //       document.querySelector(
    //         "#fc_frame, #fc_frame.fc-widget-normal"
    //       ).style.display = "block";

    //       clearInterval(interval);
    //     } else {
    //       if (timer >= 2) {
    //         clearInterval(interval);
    //       }
    //     }
    //   }, 1000);
    // }
  }, [location]);

  const handleMobileDrawerOpen = () => {
    setSwipeableOpen(true);
  };

  const handleMobileDrawerClose = () => {
    setSwipeableOpen(false);
  };

  // useEffect(() => {
  //   if (width <= 768) {
  //     let timer = 1;

  //     let interval = setInterval(() => {
  //       timer++;

  //       if (detectIfFreshchatHasLoaded()) {
  //         document.querySelector(
  //           "#fc_frame, #fc_frame.fc-widget-normal"
  //         ).style.bottom = "40px";

  //         clearInterval(interval);
  //       } else {
  //         if (timer >= 5) {
  //           clearInterval(interval);
  //         }
  //       }
  //     }, 1000);
  //   }
  // }, []);

  function detectIfFreshchatHasLoaded() {
    if (document.querySelector("#fc_frame, #fc_frame.fc-widget-normal")) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <MuiThemeProvider theme={darkTheme}>
      <CssBaseline />

      <Navbar
        open={swipeableOpen}
        handleDrawerOpen={handleMobileDrawerOpen}
        handleDrawerClose={handleMobileDrawerClose}
      ></Navbar>

      <div className={classes.content}>{props.children}</div>
    </MuiThemeProvider>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // minWidth: "450px",
    position: "fixed",
    width: "100vw",
    zIndex: "9",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  mainLogo: {
    "&:hover": {
      cursor: "pointer",
    },
    width: "100%",
    minWidth: "150px",
    maxWidth: "160px",
  },
  tool: {
    width: "100vw",
    padding: "0px 8px",
    minHeight: "45px",
    height: "45px",
    // [theme.breakpoints.up("md")]: {
    //   paddingLeft: "34px",
    //   paddingRight: "34px",
    // },
    // <div className={classes.content}>{props.children}</div>
  },
}));
